<template lang="pug">
form
  .entries-scroll
    draggable(
      :animation='200'
      :forceFallback='true'
      :list='entries'
      :preventOnFilter='false'
      filter='.disableDraggable'
      ghost-class='moving-card'
    )
      .card.card--rounded.mb-5(
        :key='entry.id'
        v-for='(entry, entryIndex) in entries'
      )
        .card-body
          .d-flex.justify-content-between.align-items-center
            label.role-label-edit-envelope {{ $t('bulkSendDetails.table.envelope') }}
            .d-flex.align-items-center
              button.disableDraggable(
                :aria-controls='`bulk-send-entry-${entry.id}`'
                :aria-label='$t("configureBulkSend.recipients.collapsable")'
                :data-bs-target='`#bulk-send-entry-${entry.id}`'
                aria-expanded='true'
                data-bs-toggle='collapse'
                type='button'
              )
                icon(name='angle-down')
              button.link--delete-recipient.disableDraggable(
                :hidden='entry.inServer'
                @click='$emit("removeEntry", entry)'
                type='button'
              )
                icon.default(name='trash')
          .collapse.show(:id='`bulk-send-entry-${entry.id}`')
            .row.mb-4(
              :key='recipient.templateRecipientIndex'
              v-for='recipient in entry.recipients'
            )
              label.role-label-edit-envelope(v-if='recipient.role') {{ recipient.role }}
              .col-12.col-md-6.form-group
                ValidationProvider(
                  :custom-messages='customMessagesName'
                  :rules='{ required: true }'
                  :vid='`vp-name-${entry.id}-${recipient.templateRecipientIndex}`'
                  mode='eager'
                  name='nome'
                  v-slot='{ errors }'
                )
                  label(
                    :for='`name-${entry.id}-${recipient.templateRecipientIndex}`'
                  ) {{ $t('modal.envelope.name') }}*
                  .form-control-icon
                    icon(name='user')
                    input.form-control.disableDraggable(
                      :class='{ "border border-danger": errors[0] }'
                      :id='`name-${entry.id}-${recipient.templateRecipientIndex}`'
                      :placeholder='$t("modal.envelope.recipientNamePlaceholder")'
                      @change='recipient.updated = true'
                      autocomplete='off'
                      type='text'
                      v-model='recipient.name'
                    )
                  small.align-items-center.text.text-danger.d-flex(
                    v-if='errors.length > 0'
                  )
                    icon(name='xmark')
                    span.text.ms-2 {{ errors[0] }}
              .col-12.col-md-6.form-group
                label(v-if='hasFeatureWhatsapp')
                  input.mx-2.form-check-input(
                    checked
                    type='radio'
                    v-model='recipient.shippingType'
                    value='email'
                  )
                  | {{ $t('modal.envelope.emailAddress') }}
                  input.mx-2.form-check-input(
                    type='radio'
                    v-model='recipient.shippingType'
                    value='whatsapp'
                  )
                  | {{ $t('modal.envelope.whatsapp') }}
                label(v-else)
                  input.mx-2.form-check-input(
                    checked
                    type='radio'
                    v-model='recipient.shippingType'
                    value='email'
                  )
                  | {{ $t('modal.envelope.emailAddress') }}
                ValidationProvider(
                  :custom-messages='customMessagesEmail'
                  :rules='{ required: recipient.shippingType !== "whatsapp", email: true, uniqueAddressesInEnvelope: entry.recipients }'
                  :vid='`vp-shipping-${entry.id}-${recipient.templateRecipientIndex}`'
                  key='email'
                  mode='eager'
                  name='e-mail'
                  v-if='recipient.shippingType !== "whatsapp"'
                  v-slot='{ errors }'
                )
                  .form-control-icon
                    icon(name='at')
                    input.form-control.disableDraggable(
                      :class='{ "border border-danger": errors[0] }'
                      :id='`email-${entry.id}-${recipient.templateRecipientIndex}`'
                      :placeholder='$t("modal.envelope.recipientEmailPlaceholder")'
                      @change='recipient.updated = true'
                      autocomplete='off'
                      v-model='recipient.email'
                    )
                  small.align-items-center.text.text-danger.d-flex(
                    v-if='errors.length > 0'
                  )
                    icon(name='xmark')
                    span.text.ms-2 {{ errors[0] }}
                ValidationProvider(
                  :custom-messages='customMessagePhone'
                  :key='`whatsapp-${entry.id}-${recipient.templateRecipientIndex}`'
                  :rules='{ required: recipient.shippingType === "whatsapp", intBrazilianPhone: isBrazilPhone, uniqueAddressesInEnvelope: entry.recipients }'
                  :vid='`vp-shipping-${entry.id}-${recipient.templateRecipientIndex}`'
                  name='phone'
                  v-if='recipient.shippingType === "whatsapp"'
                  v-slot='{ errors }'
                )
                  .form-control-icon
                    input-tel.form-control.disableDraggable(
                      :class='{ "border border-danger": errors[0] }'
                      :id='`phone-${entry.id}-${recipient.templateRecipientIndex}`'
                      :placeholder='$t("modal.envelope.recipientPhonePlaceholder")'
                      @change='recipient.updated = true'
                      @is-brazil-changed='isBrazilPhone = $event'
                      autocomplete='off'
                      type='text'
                      v-model='recipient.phone'
                    )
                  small.align-items-center.text.text-danger.d-flex(
                    v-if='errors.length > 0'
                  )
                    icon(name='xmark')
                    span.text.ms-2 {{ errors[0] }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Draggable from 'vuedraggable';
import InputTel from '@/ui/molecules/InputTel.vue';

export default {
  name: 'BulkSendManualEntries',
  components: {
    InputTel,
    Icon,
    Draggable,
  },
  props: {
    entries: {
      type: Array,
      required: true,
    },
    hasFeatureWhatsapp: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isBrazilPhone: true,
      customMessagesName: {
        required: this.$t('modal.envelope.nameRequired'),
      },
      customMessagesEmail: {
        required: this.$t('modal.envelope.emailRequired'),
        email: this.$t('modal.envelope.validEmailRequired'),
      },
      customMessagePhone: {
        required: this.$t('modal.envelope.phoneRequired'),
      },
    };
  },
};
</script>
<style scoped lang="stylus">
.entries-scroll
  max-height: 65vh
  overflow-y: auto
  padding-right: 8px

.card--rounded .col-md-1.form-group
  display: flex
  align-items: center
  justify-content: center

.link--delete-recipient
  display: flex
  align-items: center
  justify-content: center
  width: 2.5rem
  height: 2.5rem
  padding: 0
  border: 0
  background: transparent
  color: #dc3545
  font-size: 1.25rem

.card--rounded label
  font-size: 1rem

.text-danger
  font-size: 1rem
  padding-top: 0.25rem
</style>
